export function splitCardNumber(cardNumber: string | number) {
  if (!cardNumber || cardNumber === '') {
    return 'Invalid card number';
  }
  return cardNumber.toString().replace(/(\d{4}(?!\s))/g, '$1 ');
}
